import React, {useEffect, useState} from 'react';

import {ConfigProvider, Layout} from 'antd';
import './adminLayout.scss';
import SideBarMenu from '../../CommonComponents/SideBar/sidebar';
import AppInfoView from '../AppInfoView/appInfoView';
import TableHeading from '../CommonHeadingTable';
import {useLocation} from 'react-router-dom';
import {capitalizeWords, checkUrl} from '../../../Util/commonUtility';
import {useSelector} from 'react-redux';
const {Content} = Layout;

// antd theme for admin pages: primary buttons, links, checkboxes, switches,
// pagination and focus rings use the admin blue instead of antd's default
// #1677ff. Danger (delete) buttons keep antd's red. Must match --PBSS--Primary
// in body.admin-theme (global.css). Nested inside the app's ConfigProvider, so
// the app-wide form settings still apply.
const ADMIN_PRIMARY_COLOR = '#2f57a4';
const adminTheme = {
  token: {
    colorPrimary: ADMIN_PRIMARY_COLOR,
    colorLink: ADMIN_PRIMARY_COLOR,
    colorInfo: ADMIN_PRIMARY_COLOR,
  },
};

const AdminLayout = (props) => {
  const location = useLocation();
  const {sideBarState} = useSelector(({chapters}) => chapters);
  const {defaultEventNameState} = useSelector(({chapters}) => chapters);
  const {emailTemplateTypeValue} = useSelector(({emailCodes}) => emailCodes);
  const [isEventTableHeading, setIsEventTableHeading] = useState('');
  const {previewEmailSubject} = useSelector(
    ({eventTemplateSchedulers}) => eventTemplateSchedulers,
  );

  // Admin pages use the blue theme (see .admin-theme in global.css). The class
  // sits on <body> so antd popups, modals and drawers rendered outside this
  // layout pick it up too; the user site keeps its own colours.
  useEffect(() => {
    document.body.classList.add('admin-theme');
    return () => document.body.classList.remove('admin-theme');
  }, []);

  useEffect(() => {
    const url = location.pathname.replace('/admin/', '');
    setIsEventTableHeading(
      checkUrl(url, defaultEventNameState, emailTemplateTypeValue),
    );
  }, [location.pathname, defaultEventNameState, emailTemplateTypeValue]);

  return (
    <ConfigProvider theme={adminTheme}>
      <Layout prefixCls='side-bar-layout' className='layout'>
        <SideBarMenu />
        <Layout style={{background: 'none', minWidth: 0}}>
          <Content
            prefixCls='admin-layout'
            className={`site-layout-content ${
              sideBarState ? 'small-side-bar' : ''
            }`}>
            <TableHeading
  title={
    location.pathname.includes('eventEmailTemplate/preview')
      ? `Preview Email - ${previewEmailSubject || ''}`
      : capitalizeWords(location.pathname.replace('/admin/', ''))
  }
  subText={isEventTableHeading ?? ''}
/>
            {props.children}
            <AppInfoView />
          </Content>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};
export default AdminLayout;
